export type TNuevosPlanes =
{
    title: string;
    text: string;
    altImg: string;
    link: string;
    img: string;
};

export const NUEVOS_PLANES: TNuevosPlanes[] =
[
    {
        title: "Plan Gestionado",
        text: "Los profesionales de Diaphanum crearán y mantendrán tu cartera por ti sin que tengas que preocuparte de nada más.",
        altImg: "Profesional asesorando a un cliente",
        link: "/savingsPlans/iAmASaver",
        img: "iamasaver.webp"
    },
    {
        title: "Carteras Ejemplo",
        text: "Diseñadas para ofrecerte una diversificación óptima y acceso a los mejores fondos. Encuentra la estrategia que mejor se adapte a tu perfil de inversión y toma decisiones con confianza.",
        altImg: "Carteras Ejemplo",
        link: "/savingsPlans/sampleProfiles",
        img: "SampleProfiles.webp"
    },
        {
        title: "Plan Libertad",
        text: "Tú creas tu propia cartera seleccionando las inversiones que deseas con total libertad.",
        altImg: "Cliente con experiencia",
        link: "/savingsPlans/iHaveExperience",
        img: "ihaveexperience.webp"
    },
    {
        title: "Planes externos",
        text: "Obtén tus planes externos en nuestra plataforma",
        altImg: "Planes externos",
        link: "/savingsPlans/planesExternos",
        img: "planesExternos.webp"
    }
];